module.exports = __webpack_public_path__ + "img/fulong_b.c217fc2c.png";